import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import BASE_URL from "../assets/global/url";

const useCutoffData = () => {
  const [cutoffData, setCutoffData] = useState([]);

  const fetchCutoffData = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/cutoff/getCutoffs`);
      setCutoffData(response.data);
    } catch (error) {
      console.error("Error fetching cutoff data:", error);
    }
  }, []);

  useEffect(() => {
    fetchCutoffData();
  }, [fetchCutoffData]);

  return { cutoffData, refetch: fetchCutoffData };
};

export default useCutoffData;
